<template>
  <div v-if="isshow">
    <div v-if="!isTemporaryRadish" class="radishdetail-message">
      <ul>
        <li>
          <h3>{{ radishdata.姓名 }}
            <peixun type="5" style="display:inline-block;margin-left:5px;position:relative;top:3px;"></peixun>
          </h3>
          <div
            class="radish-btn radish-btn-primary radish-btn-small savemember"
            style="float:right"
            @click="changeExp('dialog')"
          >
            保存人选信息
          </div>

        </li>
        <li>
          <el-input v-model="radishdata.目前职位" style="width:49%;margin-right:5px" placeholder="目前职位" size="mini"></el-input>
          <span>手机：{{ radishdata.手机 }}</span>
        </li>
        <li>
          <el-select style="width:99%" v-model="radishdata.职能模块" multiple filterable placeholder="职能模块" size="mini">
            <el-option v-for="item in category" :key="item.名称" :label="item.名称" :value="item.名称"> </el-option>
          </el-select>
        </li>
        <li style="display:flex">
          <div style="width:80px">职业素养：</div>
          <el-checkbox-group v-model="radishdata.职业素养">
            <el-checkbox label="守时" style="margin-right:5px"></el-checkbox>
            <el-checkbox label="响应及时" style="margin-right:5px"></el-checkbox>
            <el-checkbox label="内部推动力强"></el-checkbox>
          </el-checkbox-group>
        </li>
        <li style="display:flex">
          <div style="width:80px">四色领导力：</div>
          <el-checkbox-group v-model="radishdata.四色领导力">
            <el-checkbox label="橙色-目标结果" style="margin-right:5px"></el-checkbox>
            <el-checkbox label="蓝色-专业展望" style="margin-right:5px"></el-checkbox>
            <el-checkbox label="绿色-人际交往" style="margin-right:5px"></el-checkbox>
            <el-checkbox label="黄色-辅助支持"></el-checkbox>
          </el-checkbox-group>
        </li>
        <li style="display:flex">
          <div style="width:80px">MBTI：</div>
          <el-checkbox-group v-model="radishdata.MBTI">
            <el-checkbox label="E">外向（E）</el-checkbox>
            <el-checkbox label="I">内向（I）</el-checkbox>
            <el-checkbox label="S">实感（S）</el-checkbox>
            <el-checkbox label="N">直觉（N）</el-checkbox>
            <el-checkbox label="T">思考（T）</el-checkbox>
            <el-checkbox label="F">情感（F）</el-checkbox>
            <el-checkbox label="J">判断（J）</el-checkbox>
            <el-checkbox label="P">知觉（P）</el-checkbox>
          </el-checkbox-group>
        </li>
      </ul>
    </div>
    <div v-else class="radishdetail-message">
      <h3>{{ radishName }}</h3>
    </div>
    <div class="radishdetail-score">
      <div class="average">
        <div class="score-title">评价（{{ score.数量 }}）</div>
        <span class="score-content">平均分：{{ score.平均分 }}</span>
      </div>
      <div class="alertbox">
        <el-alert
          title="实心星号表示正分，空心表示负分，分数前边的加减号点击切换状态（表示切换后的状态）"
          type="warning"
        >
        </el-alert>
      </div>
      <div class="score">
        <div class="score-left">
          <ul>
            <li v-for="item in scoretype" :key="item">
              <div class="score-title">{{ (radishdata.职能模块 && radishdata.职能模块.includes('HH-猎头')) ? typeLabel[item] : item }}</div>
              <div class="score-score">
                <i v-if="score[item] >= 0" class="el-icon-star-on"></i> <i v-else class="el-icon-star-off"></i>
                <span>{{ score[item] }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="score-right">
          <ul>
            <li v-for="item in scoretype" :key="item">
              <i class="el-icon-remove-outline btn" v-if="type[item] == '+'" @click="changetype(item, '-')"></i>
              <i
                class="el-icon-circle-plus-outline btn"
                v-else-if="type[item] == '-'"
                @click="changetype(item, '+')"
              ></i>
              <el-rate
                v-model="newscore[item]"
                v-if="type[item] == '+'"
                void-icon-class="el-icon-star-on"
                :icon-classes="['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on']"
                style="width:85%;display:inline-block"
              ></el-rate>
              <el-rate
                v-model="newscore[item]"
                v-else-if="type[item] == '-'"
                :colors="['#da3c3c', '#da3c3c', '#da3c3c']"
                void-icon-class="el-icon-remove"
                :icon-classes="['el-icon-remove', 'el-icon-remove', 'el-icon-remove']"
                style="width:85%;display:inline-block"
              ></el-rate>
            </li>
          </ul>
        </div>
        <ul class="grades-box">
          <li v-for="grade in grades" :key="grade._id">
            <span class="remark-date" v-if="grade.user">
              {{ getDate(grade.createdAt) }} <span class="remark-time">{{ getTime(grade.createdAt) }}</span> --
              {{ grade.user }}
            </span>
            <span class="remark-date" v-else> 2019/4/20 <span class="remark-time">00:00</span> -- admin </span>
            <span v-for="type in scoretype" :key="type" v-if="grade[type]"> {{ (radishdata.职能模块 && radishdata.职能模块.includes('HH-猎头')) ? typeLabel[type] : type }}:{{ grade[type] }} </span>
            <span class="grades-evaluate">{{ grade.evaluate }}</span>
          </li>
          <li v-for="grade in interviewScore" :key="grade._id">
            <span class="remark-date" v-if="grade.user">
              {{ getDate(grade.updatedAt) }} <span class="remark-time">{{ getTime(grade.updatedAt) }}</span> --
              {{ grade.user }}
            </span>
            <el-tag size="mini">{{ grade.意见 }}</el-tag>
            <el-tag size="mini">第{{ grade.轮数 }}轮</el-tag>
            <span class="evaluate">{{ grade.综合评价 }}</span>
            <el-tag size="mini" type="warning" v-for="(val, type) in grade['projectGrades']" :key="type" v-if="val">
              {{ (radishdata.职能模块 && radishdata.职能模块.includes('HH-猎头')) ? typeLabel[type] : type }}:{{ val }}
            </el-tag>
          </li>
        </ul>
        <div class="evaluate">
          <el-input type="textarea" :rows="3" placeholder="候选人评价备注" v-model="evaluate"> </el-input>
        </div>
        <div class="radish-btn radish-btn-primary radish-btn-small" style="float:right;margin:8px;" @click="savescore">
          保存评分
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as fixedvariant from '../../statistics/variant/fixedvariant.js'
import * as commonvariant from '../../statistics/variant/commonvariant.js'
export default {
  data() {
    return {
      evaluate: '',
      isshow: false,
      radishId: '',
      score: JSON.parse(JSON.stringify(commonvariant.得分结果)),
      radishdata: {职业素养: [], 四色领导力:[], MBTI: []},
      // tabletype1: JSON.parse(JSON.stringify(fixedvariant.专业职级表头)),
      // tabletype2: JSON.parse(JSON.stringify(fixedvariant.管理职级表头)),
      newscore: JSON.parse(JSON.stringify(commonvariant.分数统计)),
      category: [],
      scoretype: ['业绩', '管理能力', '专业高度', '资源', '口碑', '情商'],
      typeLabel: {
        '业绩': 'BD能力',
        '管理能力': '预付费',
        '专业高度': '谈offer',
        '资源': '交付',
        '口碑': 'Mapping',
        '情商': '管理能力',
      },
      type: {
        业绩: '+',
        管理能力: '+',
        专业高度: '+',
        资源: '+',
        口碑: '+',
        情商: '+',
      },
      grades: [],
      interviewScore: [],
      isTemporaryRadish: false,
      radishName: '',
      submiting: false,
    }
  },
  methods: {
    async getInterviewScore(rid) {
      const res = await app.service('company').getInterviewScore({ rid })
      console.log(res)
      if (res.status === 'success') this.interviewScore = res.data
      else this.$message.error(res.msg)
    },
    getTime(time) {
      let hour = new Date(time).getHours()
      let minute = new Date(time).getMinutes()
      hour = hour < 10 ? `0${hour}` : hour
      minute = minute < 10 ? `0${minute}` : minute
      return `${hour}:${minute}`
    },
    getDate(val) {
      let year = new Date(val).getFullYear()
      let month = new Date(val).getMonth() + 1
      let data = new Date(val).getDate()
      return `${year}/${month}/${data}`
    },
    async setOption() {
      if (!app.categories) {
        await app.getCats()
      }
      this.category = app.categories
    },
    async open(radishId, type, name) {
      this.isTemporaryRadish = type
      this.radishId = radishId
      this.getscore()
      this.getInterviewScore(radishId)
      if (!this.isTemporaryRadish) {
        const { data } = await app.service('radish').fetch({
          _id: radishId,
          fields: {
            姓名: 1,
            手机: 1,
            公司: 1,
            部门: 1,
            职能模块: 1,
            目前职位: 1,
            管理职级: 1,
            专业职级: 1,
            职业素养: 1,
            四色领导力: 1,
            MBTI: 1,
          },
        })
        if (!data || data.length == 0) {
          this.radishName = name
          this.isTemporaryRadish = true
        } else {
          this.radishdata = Object.assign({职能模块: [], 职业素养: [], 四色领导力:[], MBTI: []}, data[0])
        }
      } else {
        this.radishName = name
      }
      this.isshow = true
      this.init()
    },
    async getscore() {
      let result = await window.app.service('company').getRadishScore(this.radishId)
      this.score = result.score
      this.evaluate = ''
      this.grades = result.grades
    },
    changetype(type, val) {
      this.type[type] = val
    },
    init() {
      this.newscore = {
        业绩: 0,
        管理能力: 0,
        专业高度: 0,
        资源: 0,
        口碑: 0,
        情商: 0,
      }
      for (let key in this.type) {
        this.type[key] = '+'
      }
    },
    async changeExp() {
      let option = {
        目前职位: this.radishdata.目前职位,
        管理职级: this.radishdata.管理职级,
        专业职级: this.radishdata.专业职级,
        职业素养: this.radishdata.职业素养,
        四色领导力: this.radishdata.四色领导力,
        MBTI: this.radishdata.MBTI,
      }
      let result = await window.app.service('radish').modifyById({ _id: this.radishdata._id, data: option })
      if (result.status === 'success') {
        this.$message.success(result.msg)
      }
    },
    async savescore() {
      if (this.submiting) return this.$message('提交中，请勿重复提交')
      this.submiting = true
      let option = JSON.parse(JSON.stringify(this.newscore))
      for (let key in this.type) {
        if (this.type[key] == '-') {
          option[key] = -option[key]
        }
      }
      option.rid = this.radishId
      let result = await app.service('company').insertRadishScore({ score: option, evaluate: this.evaluate })
      this.submiting = false
      if (result.status == 200) {
        this.getscore()
        this.$message('保存成功')
        this.init()
      }
    },
  },
  mounted() {
    this.setOption()
  },
}
</script>
<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
}

i {
  font-size: 18px;
  color: #f9152a;
}

ul {
  padding: 0;
  list-style: none;
}

.radishdetail-message {
  padding-bottom: 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ddd;
}
.radishdetail-message li {
  margin-bottom: 5px;
}

.savemember {
  position: absolute;
  top: 10px;
  right: 36px;
  z-index: 4;
}

.radishdetail-score {
  background-color: #fff;
  padding: 5px;
}

.average {
  height: 30px;
  padding: 0 16px;
  margin: 0 -10px;
  line-height: 30px;
  text-align: center;
  background-color: skyblue;
  border-radius: 5px;
}

.alertbox {
  margin: 0 -10px;
}

.score-title {
  float: left;
}

.score-content {
  margin: 0 auto;
}

.score-left,
.score-right {
  float: left;
  width: 50%;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.score-left {
  border-right: 1px solid #eee;
}

.score-right {
  padding-left: 16px;
}

.score-left li {
  overflow: hidden;
  line-height: 32px;
}

.score-right li {
  display: flex;
  align-items: center;
  height: 32px;
}

.score-score {
  float: right;
  margin-right: 20px;
}

.score-score i {
  color: rgb(247, 186, 42);
}

.btn {
  font-size: 20px;
  color: #807f7f;
  text-align: center;
  cursor: pointer;
}

.evaluate {
  float: left;
  width: 100%;
  padding-top: 8px;
  overflow: hidden;
}
.grades-box {
  max-height: 200px;
  overflow: auto;
  width: 100%;
}
.grades-evaluate {
  color: #807f7f;
  padding-left: 8px;
}
</style>
